import ForecastingTableController from './forecasting-sites.controller';

const template = require<string>('./forecasting-sites.html');

const forecastingSitesComponent:ng.IComponentOptions = {
	bindings: {
		onSelectedStationChange: '&',
	},
  	controller: ForecastingTableController,
  	template
};
export default forecastingSitesComponent;



/** WEBPACK FOOTER **
 ** ./app/hydromet/forecasting/process/forecasting-sites.component.ts
 **/